<template>
    <div class="kp-container-wrapper">
        <div class="title">{{ $t('CLIENT_HOME_KPCONTACT') }}</div>
        <div v-for="list in data" :key="list.key" class="wl-client-container">
            <div v-for="item in list" :key="item.key" class="wl-contact-item border-normal">
                <div class="flex item-center">
                    <svg-icon icon-name="user-usename" icon-color="#ccced2" :size="24"></svg-icon>
                    <span v-if="item.cnUserName">{{ item.cnUserName }}</span>
                    <span v-if="item.userName">{{ item.userName }}</span>
                    <span v-if="item.profitCenter">({{ item.profitCenter }})</span>
                </div>
                <div class="flex item-center">
                    <svg-icon icon-name="user-position" icon-color="#ccced2" :size="24"></svg-icon>
                    <span>{{ item.title }}</span>
                </div>
                <div class="flex item-center">
                    <svg-icon icon-name="user-email" icon-color="#ccced2" :size="24"></svg-icon>
                    <span>{{ item.email }}</span>
                </div>
                <div class="flex item-center">
                    <svg-icon icon-name="user-phone" icon-color="#ccced2" :size="24"></svg-icon>
                    <span>{{ item.phone }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SvgIcon from '@/components/svgIcon/index'

export default {
    components:{SvgIcon},
    computed: {
        ...mapGetters('common', {
            getCollapse: 'getCollapse'
        })
    },
    props: {
        data: {
            type: [Object, Array],
            default: []
        }
    }
}
</script>
<style scoped>
.title {
    font-size: 14px;
    color: #333333;
    font-weight: bolder;
    height: 24px;
    line-height: 24px;
}

.wl-client-container {
    display: flex;
}

.wl-contact-item {
    background: #fff;
    font-size: 24px;
    width: calc((100% - 45px) / 3);
    text-align: left;
    margin: 12px 15px 0 0;
    padding: 12px;
}
.wl-client-container .wl-contact-item:nth-last-child(1) {
    margin-right: 0;
}
.wl-contact-item div:nth-child(1) span {
    font-weight: 700;
    text-decoration: none;
    color: #555555;
    font-size: 12px;
}

.wl-contact-item div:nth-child(2) span {
    font-weight: 400;
    text-decoration: underline;
    color: #4f4f4f;
    font-size: 12px;
}

.wl-contact-item div:nth-child(3) span {
    font-weight: 400;
    text-decoration: underline;
    color: #4f4f4f;
    font-size: 12px;
}

.wl-contact-item div:nth-child(4) span {
    font-weight: 400;
    text-decoration: underline;
    color: #4f4f4f;
    font-size: 12px;
}

.wl-contact-item .fa {
    color: #a072a8;
    font-size: 12px;
    margin-right: 8px;
}
</style>
